<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Menu</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo v-model="table.search"
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
	 	 		></v-text-field>
				<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>	
	 	 	 	<v-data-table v-model="selected"
              :headers="table.headers"
              :items="table.items"
              :loading="table.loading"
              :search="table.search"
              class="elevation-1"
              item-key="id" show-select 
	 	 	 	 >
		 	 	 	 <template v-slot:item.icon="props">
	 	 	 	   		<td><v-icon>{{ props.item.icon }}</v-icon></td>
		 	 	 	 </template>
		 	 	 	 <template v-slot:item.submenu="props">
	 	 	 	   		<td>
	              <v-icon color="success" v-if="props.item.submenu == 1">fas fa-check</v-icon>
	              <v-icon color="error" v-else>fas fa-times</v-icon>
	            </td>
		 	 	 	 </template>
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" :to="'/admin/menu/edit/' + props.item.id " small fab> <v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   			<v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
	 	 	 	   			<v-btn text color="info" small fab @click="showItem(props.item)"><v-icon>fa fa-eye</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" to="/admin/menu/create">Agregar nuevo Menu</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalShow.active"
	 	  scrollable 
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	    <v-card-title primary-title>
	 	      <h3 class="display-1">Item de menu</h3>
	 	    </v-card-title>
	 	    <v-card-text>
	 	      <v-list>
	 	      	  <v-list-item>
	              <v-list-item-avatar>
	                <v-icon>{{ modalShow.menu.icon }}</v-icon>
	              </v-list-item-avatar>

	              <v-list-item-content>
	                <v-list-item-title v-html="modalShow.menu.name"></v-list-item-title>
	                <v-list-item-sub-title v-html=" modalShow.menu.link "></v-list-item-sub-title>
	              </v-list-item-content>
	            </v-list-item>
	 	        
	 	        <v-layout row wrap>
	 	        	<v-flex xs10 offset-xs1>
		 	          <v-list>
		 	          	<v-list-item v-for="item in modalShow.submenu">
			              <v-list-item-avatar>
			                <v-icon> {{ item.icon }}</v-icon>
			              </v-list-item-avatar>

			              <v-list-item-content>
			                <v-list-item-title v-html="item.name"></v-list-item-title>
			                <v-list-item-sub-title v-html="item.link "></v-list-item-sub-title>
			              </v-list-item-content>
			            </v-list-item>
		 	          </v-list>
	 	        	</v-flex>
	 	        </v-layout>
	 	      </v-list>
	 	    </v-card-text>
	 	  </v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable  
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar Menu</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿ESTA SEGURO DE BORRAR Menu?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="deleteItem()">Aceptar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				selected: [],
				baseRoute: process.env.VUE_APP_URL + 'api/menu',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalEdit: {
					active: false,
					data: {}
				},
				modalShow: {
					active: false,
					menu: {},
					submenu: {}
				},
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selects: [],
			}
		},
		methods: {
			getData(){
				this.table.loading = true;	
				axios.get(this.baseRoute).then((res) => {
					this.table.loading = false;
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
				}).catch((error) => {
					this.table.loading = false;
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			create(){
				this.modalCreate.active = true;
				this.modalCreate.data = [];
			},
			store(){
				axios.post(this.baseRoute + "/store", this.modalCreate.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Creado exitosamente";
						this.alert.color = "success";
						this.getData();
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.modalEdit.active = true;
				this.modalEdit.data = item;
			},
			update(){
				axios.put(this.baseRoute + "/admin/ruta/edit/" + this.modalEdit.data.id, this.modalEdit.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Actualizado correctamente";
						this.alert.color = "success";					
						this.getData();

					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			showItem(item){
				this.modalShow.active = true;
				this.modalShow.menu = item;
				axios.get(this.baseRoute + "/edit/" + item.id).then((res) => {
					this.modalShow.submenu = res.data.submenu;
				})
			},
			deleteItem(){
				axios.post(this.baseRoute + "/destroy", this.modalDelete.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
						this.modalDelete.active = false
						this.getData();

					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.modalDelete.active = false
						this.getData();
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
					this.modalDelete.active = false
				});
			},
		},
		watch: {

		},
		computed: {

		},
	}
</script>